import { Component, OnInit ,ViewChild} from '@angular/core';
import { formatDate } from '@angular/common';
import { BulkRequestService } from 'src/app/services/bulk-request/bulk-request.service';
import { MiTableComponent } from 'src/app/shared/mi-table/mi-table.component';
import { MsalService } from '@azure/msal-angular';
import { FormsModule, Validators } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import Swal from 'sweetalert2';
import { saveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";
import { ApprovalDashBoardService } from 'src/app/services/approval-dashboard/approval-dashboard.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormControl } from '@angular/forms';
import { BillingAdjustmentStatusEnum, BillingAdjustmentStatusEnumDisplay, EmptyFallbackPipe, formatMoney, isNullOrEmptyOrWhitespace } from 'src/utilities';
import { DigitalCopyPdfService } from "src/app/services/digital-copy-pdf/digital-copy-pdf.service";


@Component({
    selector: 'app-bulk-request-history',
    imports: [MiTableComponent, FormsModule, NgxSpinnerModule, SharedModule],
    templateUrl: './bulk-request-history.component.html',
    styleUrl: './bulk-request-history.component.scss'
})
export class BulkRequestHistoryComponent implements OnInit {
  @ViewChild(MiTableComponent) miTable!: MiTableComponent;
  searchText = '';
  historyData: any[] = [];
  detailData: any[] = [];
  isViewingDetails = false;
  selectedMainRow: any = null;
  isViewMode = true;
  showAction = true;
  isDetailView = false;
  fileChanged = false;


  editedMainRow: any = null;
  editedDetailRows: any[] = [];
  deletedDetailIds: number[] = [];
  newFiles: File[] = [];
  selectedFiles:File  [] = [];
  selectedFileNames:any [] = [];
  fileErrors: string = '';
  isLoading:boolean=false;

  private readonly maxFileSize = 10 * 1024 * 1024;
  private readonly allowedFileTypes = ['.xlsx', '.xls', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];


  readonly fieldMapping: { [apiKey: string]: string } = {
    adjReqId: 'Adj Req Id',
    customerCount: 'Total Customers',
    brAdjType: 'Adjustment Type',
    descriptionComment: 'Description',
    amount: 'Amount',
    specialInstructions: 'Special Instructions',
    detailsId: '_Details Id',
    billingSite: 'Billing Site',
    mms: '#MMS',
    customerName: 'Customer Name',
    totalCorrectCharges: 'Amount',
    checkRequest: 'Check Request',
    adjustmentMethod:'Adjustment Method',
    ae: 'AE/Sales Contact',    
    adjNetAmount:'Net Amount',
    remitAddress:'Remit Address',
    adjRequestDate:'Requested Date',   
    statusName:'Status',  
    // rejectionReason:'MI Remarks',
    // approver:'Actioned By (MI)',
    // gbsStatus:'GBS Status',
    gbsRemarks:'GBS Remarks',
    gbsApprover: 'Actioned By (GBS)'
  };
  
  readonly invoiceFieldMapping: { [apiKey: string]: string } = {
    adjReqId: 'Adj Req Id',
    customerCount: 'Total Customers',
    brAdjType: 'Adjustment Type',
    descriptionComment: 'Description',
    amount: 'Amount',
    specialInstructions: 'Special Instructions',
    detailsId: '_Details Id',
    billingSite: 'Billing Site',
    mms: '#MMS',
    customerName: 'Customer Name',
    totalCorrectCharges: 'Amount',
    checkRequest: 'Check Request',
    adjustmentMethod:'Adjustment Method',
    ae: 'AE/Sales Contact',    
    adjNetAmount:'Net Amount',
    remitAddress:'Remit Address',
    adjRequestDate:'Requested Date',   
    status:'MI Status',
    // statusName:' MI Status',  
    firstLevelRemarks:'MI Remarks',
    firstLevelApprover:'Actioned By (MI)',
    gbsStatus:'GBS Status',
    gbsRemarks:'GBS Remarks',
    gbsApprover: 'Actioned By (GBS)'
  };

  readonly firstTableValidationRules: { [column: string]: any[] } = {
    'Total Customers': [Validators.required, Validators.pattern(/^\d+$/)],
    'Adjustment Type': [Validators.required],
    'Amount': [Validators.required, Validators.pattern(/^-?\d+(\.\d{1,2})?$/)],
    'Special Instructions': [Validators.required,Validators.maxLength(100),  Validators.pattern(/^(?!\s*$).+/)],
    'Description':[Validators.required,Validators.maxLength(100),  Validators.pattern(/^(?!\s*$).+/)]
  };

  readonly detailsValidationTableRules: { [column: string]: any[] } = {
    'Billing Site': [Validators.required,Validators.pattern(/^\d+$/)],
    '#MMS': [Validators.required,Validators.pattern(/^[a-zA-Z0-9\W]+$/), Validators.maxLength(50)],
    // Pattern allows alphanumeric characters and special characters
    'Customer Name': [Validators.required,Validators.maxLength(50),Validators.pattern(/^(?!\s*$).+/)],
    'Amount': [Validators.required,Validators.pattern(/^-?\d+(\.\d{1,2})?$/)],
    // 'Amount': [Validators.required,Validators.pattern(/^-?\d+(\.\d+)?$/)],
    'Check Request': [Validators.required,this.checkRequestValidator(),  Validators.pattern(/^(?!\s*$).+/)],
    'AE/Sales Contact': [Validators.required,Validators.maxLength(50),Validators.pattern(/^[a-zA-Z ]*$/),  Validators.pattern(/^(?!\s*$).+/)],
    'Description':[Validators.required,Validators.maxLength(100),  Validators.pattern(/^(?!\s*$).+/)],
     'Remit Address': [this.conditionalRemitAddressValidator(),Validators.maxLength(100),  Validators.pattern(/^(?!\s*$).+/)]
  };

  constructor(
    private bulkRequestService: BulkRequestService,
    private approvalDashBoardService: ApprovalDashBoardService,
    private msalService: MsalService,
    private spinner: SpinnerService,
    private toastr: ToastrService,
    private digitalCopyPdfService : DigitalCopyPdfService
  ) {}

  ngOnInit(): void {
    this.loadHistory();
  }
loadHistory(): void {
  this.spinner.showSpinner();
  this.isViewingDetails = false;
  this.selectedMainRow = null;
  this.editedMainRow = null;
  this.editedDetailRows = [];
  this.deletedDetailIds = [];

  const clientId = this.msalService.instance.getActiveAccount()?.username ?? 'system';
  const notYetStatuses = [1,2,3,4,5,14,15];
  this.isLoading=true;
  this.bulkRequestService.getBulkRequestHistory(clientId).subscribe({
    next: (data) => {
     
      data.forEach(y => {
        y.statementStatusName=[];
        y.statementStatus.forEach(x => {
        x.gbsStatus = x.isGBSNMF
                          ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation] :
                           notYetStatuses.includes(x.statusId) ? '--' : BillingAdjustmentStatusEnumDisplay[x.statusId];
                        if (
                        (x.gbsStatus === 'GBS Need More Information' && x.statusId !== BillingAdjustmentStatusEnum.Submitted ) ||
                        (x.gbsStatus !== '--' && x.gbsStatus !== 'GBS Need More Information')
                      ) {
                        x.status = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.MIApproved];
                      } else {
                        x.status = BillingAdjustmentStatusEnumDisplay[x.statusId]; 
                      }   
                      y.statementStatusName.push(x.gbsStatus);
                      y.statementStatusName.push(x.status);
                    });
                   // Check if array contains "Need More Information" or other specific values
                   y.isAllowEdit = y.statementStatusName.some(status => {
                    const normalizedStatus = String(status || '').trim().toLowerCase();
                    return normalizedStatus.includes('need more information') || 
                           normalizedStatus === 'gbs need more information' ||
                           normalizedStatus === 'submitted' 
                          //  ||
                          //  normalizedStatus === '--'
                           ;
                  });
      });
      
      this.historyData = (data || []).map(item => {
        
        const transformed: any = {};
        for (const key in this.fieldMapping) {
          if (item[key] !== undefined) {
            transformed[this.fieldMapping[key]] = key === 'adjRequestDate'
              ? item[key]
                ? formatDate(item[key], 'MM/dd/yyy', 'en-US')
                : '-'
              : item[key] ?? '_';
          }
        }
    //transformed['adjRequestDate'] = formatDate(item.adjRequestDate,'MM/dd/yyyy', "en-US");
    transformed._uploadedFiles = item.uploadedFiles ?? []; // keep actual files here
    transformed._isAllowEdit=item.isAllowEdit;
    transformed._statementStatusName=item.statementStatusName;    
        return transformed;
      });

    },
    error: (error) => console.error('Failed to fetch history', error),
    complete: () => 
      {
        this.isLoading=false;
        this.spinner.hideSpinner();
      }

  });
}
  

loadDetailsByAdjReqId(adjReqId: number): void {
  this.spinner.showSpinner();
  this.isLoading=true;
  // 🧹 Clear previous selections
  this.selectedFiles = [];
  this.selectedFileNames = [];
  this.fileErrors = '';
  this.fileChanged = false;
  const notYetStatuses = [1,2,3,4,5,14,15];
  this.bulkRequestService.getBulkUploadDetailsByAdjReqId(adjReqId).subscribe({
    next: (data) => {
     
      data.forEach(x => {     
        x.gbsStatus = x.isGBSNMF
                          ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation] :
                           notYetStatuses.includes(x.statusId) ? '--' : BillingAdjustmentStatusEnumDisplay[x.statusId];
                        if (
                        (x.gbsStatus === 'GBS Need More Information' && x.statusId !== BillingAdjustmentStatusEnum.Submitted ) ||
                        (x.gbsStatus !== '--' && x.gbsStatus !== 'GBS Need More Information')
                      ) {
                        x.status = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.MIApproved];
                      } else {
                        //x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
                        if(x.statusId==1){
                          x.status = '--'
                        }else{
                          x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
                        }             
        
                      }   
                      //x.status = BillingAdjustmentStatusEnumDisplay[x.statusId]
      });
      this.detailData = (data || []).map((item: any) => {
        const transformed: any = {};
        for (const key in this.invoiceFieldMapping) {
          if (item[key] !== undefined) {
            transformed[this.invoiceFieldMapping[key]] = item[key] ?? '_';
          }
        }
        transformed._statusId=item.statusId;
        return transformed;
      });

      // Load files only for this specific row
      if (this.selectedMainRow && this.selectedMainRow._uploadedFiles?.length) {
        this.selectedMainRow._uploadedFiles.forEach((element) => {
          element.name = element.fileName;
          this.selectedFiles.push(element);
          this.selectedFileNames.push(element.fileName);
        });
      }
      this.isLoading=false;
    },
    error: (error) => console.error('Failed to fetch details', error),
    complete: () => {
      this.spinner.hideSpinner();
      this.isLoading=false;
    } 
  });
}

  
  openAcceptOrRejectDialog(e) {
    if (e.callFrom === 'download') {
      if(e.details.isFileUploaded)
      {
        this.spinner.showSpinner();
        this.approvalDashBoardService.DownloadUploadedFiles(e.details.adjReqId)
          .subscribe({
            next: data => {
              const filename = `AdjustmentRequest_${e.details.adjReqId}.zip`;  
              const blob = new Blob([data], { type: 'application/zip' });
              saveAs(blob, filename);
              this.spinner.hideSpinner();
              this.toastr.success('File Downloaded Successfully', 'Success');
            },
            error: () => {
              this.spinner.hideSpinner();
              this.toastr.error('Error downloading file', 'Error');
            }
          });
      }
else{
        this.toastr.warning('No Files Uploaded', 'warning');
      }
    }
          else if (e.callFrom === 'viewDetails') {
  this.isDetailView = true;
  this.loadDetailsByAdjReqId(e.details.adjReqId);
}
  }

onAction(event: { action: string; row: any }): void {
  const adjReqId = event.row['Adj Req Id'];
  const detailsId = event.row['_Details Id'];
 
  // 🔸 Delete Detail Row
  if (event.action === 'delete' && detailsId) {
 
    if(this.detailData.length <=1){
      Swal.fire({
           title: "A request must have atleast 1 statement detail.",
           icon: "info",
           confirmButtonText: "OK",
           allowOutsideClick: false,
          });
          return;
    }else{
      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to delete this detail row?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.detailData = this.detailData.filter(d => d['_Details Id'] !== detailsId);
          this.deletedDetailIds.push(detailsId);
  
            // ✅ Update Total Customers count
        const updatedCount = this.detailData.length;
        if (this.selectedMainRow) {
          this.selectedMainRow['Total Customers'] = updatedCount;
          this.editedMainRow = {
            ...this.editedMainRow,
            'Total Customers': updatedCount
          };
        }
        this.updateTopAmountFromTable();
  
          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'The detail row has been removed.',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
      return;
    }    
  }

  // 🔹 Delete Entire Main Row (Cancel Request)
  if (event.action === 'delete' && adjReqId && !detailsId) {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete the request #${adjReqId}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        const cancelledBy = this.msalService.instance.getActiveAccount()?.username ?? '';
        this.spinner.showSpinner();
        this.bulkRequestService.cancelBulkRequest(adjReqId, cancelledBy).subscribe({
          next: (success) => {
            Swal.fire({
              icon: 'success',
              title: 'Request Cancelled',
              text: `Bulk adjustment request #${adjReqId} has been cancelled.`,
              confirmButtonColor: '#4CAF50'
            });
            this.updateTopAmountFromTable();
            this.onBackToHistory();
          },
          error: (error) => {
            console.error('Cancel failed:', error);
            Swal.fire({
              icon: 'error',
              title: 'Cancel Failed',
              text: 'An error occurred while cancelling the request.'
            });
          },
          complete: () => this.spinner.hideSpinner()
        });
      }
    });
    return;
  }

  // 📁 Download Uploaded Files
if (event.action === 'download' && adjReqId) {
  
  const uploadedFiles = event.row._uploadedFiles ?? [];

  const hasUploadedFiles = uploadedFiles.some(f => f?.isActive);

  if (hasUploadedFiles) {
    this.spinner.showSpinner();

    this.approvalDashBoardService.DownloadUploadedFiles(adjReqId).subscribe({
      next: (data) => {
        const filename = `AdjustmentRequest_${adjReqId}.zip`;
        const blob = new Blob([data], { type: 'application/zip' });
        saveAs(blob, filename);

        this.spinner.hideSpinner();
        this.toastr.success('File downloaded successfully.', 'Success');
      },
      error: () => {
        this.spinner.hideSpinner();
        this.toastr.error('Error downloading file.', 'Error');
      }
    });

  } else {
    this.toastr.warning('No active uploaded files found.', 'Warning');
  }

  return;
}
if (event.action === 'digitalCopy' && adjReqId) {
  
  this.digitalCopyPdfService.downloadDigitalCopy(adjReqId);

  return;
}


  // 🔸 View/Edit Details
 if (adjReqId) {
  this.selectedMainRow = event.row;
  this.isViewingDetails = true;
  this.editedMainRow = null;
  this.editedDetailRows = [];
  this.deletedDetailIds = [];
  // this.showAction = true; 
  this.showAction = event.action !== 'view';
  this.loadDetailsByAdjReqId(adjReqId);
}

}

onBackToHistory(): void {
  this.detailData = [];
  this.selectedMainRow = null;
  this.editedMainRow = null;
  this.editedDetailRows = [];
  this.deletedDetailIds = [];
  this.selectedFiles = [];
  this.selectedFileNames = [];
  this.fileErrors = '';
  this.fileChanged = false;

  this.loadHistory();
  this.showAction = true;
}

  onRowUpdate(updatedRow: any): void {
    if (updatedRow['Adj Req Id']) {
      this.editedMainRow = updatedRow;
    } else if (updatedRow['_Details Id']) {
      const index = this.editedDetailRows.findIndex(r => r['_Details Id'] === updatedRow['_Details Id']);
      if (index >= 0) {
        this.editedDetailRows[index] = updatedRow;
      } else {
        this.editedDetailRows.push(updatedRow);
      }
    }
    
    this.updateTopAmountFromTable();
  
    
  }

  onRowEditCancel(row: any): void {}

  onValidationError(error: string): void {
    console.warn('Validation error:', error);
  }
submitUpdatedRequest(): void {
  if (!this.selectedMainRow || !this.detailData) return;
    if (this.hasValidationErrors()) {
    this.handleError('Please fix validation errors (highlighted in red) before submitting.');
    return;
  }

  const adjReqId = this.selectedMainRow['Adj Req Id'];

  const finalMain = {
    adjReqId,
    descriptionComment: this.editedMainRow?.['Description'] ?? this.selectedMainRow['Description'],
    specialInstructions: this.editedMainRow?.['Special Instructions'] ?? this.selectedMainRow['Special Instructions'],
    brAdjType: this.editedMainRow?.['Adjustment Type'] ?? this.selectedMainRow['Adjustment Type'],
    customerCount: this.editedMainRow?.['Total Customers'] ?? this.selectedMainRow['Total Customers'],
    adjNetAmount: this.selectedMainRow['Net Amount'],
    recordUpdatedBy: this.msalService.instance.getActiveAccount()?.username ?? ''
  };
  const finalDetails = this.detailData.map(original => {
    const updated = this.editedDetailRows.find(r => r['_Details Id'] === original['Details Id']);
    const source = updated || original;

    return {
      detailsId: source['_Details Id'] || 0,
      adjReqId,
      customerName: source['Customer Name'],
      mms: source['#MMS'],
      billingSite: source['Billing Site'],
      ae: source['AE/Sales Contact'],
      checkRequest: source['Check Request'],
      totalCorrectCharges: source['Amount'],
      remitAddress: source['Remit Address'] ?? '',
      adjustmentMethod: source['Adjustment Method'] ?? ''
    };
  });

  this.spinner.showSpinner();

  const payload = {
    ...finalMain,
    invoiceAdjustmentDetails: finalDetails
  };

  this.bulkRequestService.updateBulkRequest(payload).subscribe({
    next: (resp) => {
      const formData = new FormData();
       var tempFiles : any = this.selectedFiles;
       var newFiles= tempFiles.filter(x=> !x.uploadId);
       var oldFiles= tempFiles.filter(x=> x.uploadId);

      if (this.fileChanged && this.selectedFiles.length > 0) {
        // Handle NEW files
        newFiles.forEach(file => formData.append('files', file));

        // Handle OLD files metadata
        oldFiles.forEach((file, i) => {
          formData.append(`uploadedFiles[${i}][fileName]`, file.fileName);
          formData.append(`uploadedFiles[${i}][filePath]`, file.filePath);
          formData.append(`uploadedFiles[${i}][fullFileName]`, file.fullFileName);
          formData.append(`uploadedFiles[${i}][adjReqId]`, file.adjReqId);
          formData.append(`uploadedFiles[${i}][isActive]`, file.isActive);
          formData.append(`uploadedFiles[${i}][name]`, file.name);
          formData.append(`uploadedFiles[${i}][uploadId]`, file.uploadId);
          formData.append(`uploadedFiles[${i}][fileType]`, file.fileType);
        });

        formData.append('adjReqId', adjReqId.toString());

        const uploadObservable = oldFiles.length > 0
          ? this.bulkRequestService.uploadEditBillingAdjustmentRequestFiles(formData)
          : this.bulkRequestService.uploadBillingAdjustmentRequestFiles(formData, adjReqId);

        uploadObservable.subscribe({
          next: () => {
            // Swal.fire({
            //   icon: 'success',
            //   title: 'Request Updated',
            //   text: `Request ID ${resp.adjReqId} updated and files uploaded successfully.`,
            //   confirmButtonColor: '#4CAF50'
            // });
              Swal.fire({
                        icon: 'success',
                        title: `Request ID ${resp.adjReqId} updated successfully.`,
                        confirmButtonText: "OK",
                        //text: `Request submitted successfully (AdjReqId: ${response.adjReqId})`,
                        confirmButtonColor: '#4CAF50',
                        allowOutsideClick: false,
                      });
            this.onBackToHistory();
          },
          error: (err) => {
            console.error('File upload failed:', err);
            // Swal.fire({
            //   icon: 'warning',
            //   title: 'Partial Success',
            //   text: `Request updated but file upload failed.`,
            // });
              Swal.fire({
                      title:`Request updated but file upload failed.`,
                      icon: "error",
                      confirmButtonText: "OK",
                      allowOutsideClick: false,
                      customClass: {
                       title: 'custom-title'
                      }
                    });
            this.onBackToHistory();
          },
          complete: () => this.spinner.hideSpinner()
        });
      } else {
        // Swal.fire({
        //   icon: 'success',
        //   title: 'Update Successful',
        //   text: `Request ID ${resp.adjReqId} updated successfully.`,
        //   confirmButtonColor: '#4CAF50'
        // });
        Swal.fire({
          icon: 'success',
          title: `Request ID ${resp.adjReqId} updated successfully.`,
          confirmButtonText: "OK",
          //text: `Request submitted successfully (AdjReqId: ${response.adjReqId})`,
          confirmButtonColor: '#4CAF50',
          allowOutsideClick: false,
        });
        this.onBackToHistory();
        this.spinner.hideSpinner();
      }
    },
      error: (response) => {
        this.spinner.hideSpinner();
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed. Please check the data marked in red. Customer Name/Billing Site',
          confirmButtonText: "OK",
          //text: `Request submitted successfully (AdjReqId: ${response.adjReqId})`,
          //confirmButtonColor: '#4CAF50',
          allowOutsideClick: false,
        });
        //this.handleError('Upload Failed. Please check the data marked in red. Customer Name/Billing Site');
        if (response?.error?.result?.invoiceDetails?.length) {
          this.detailData = this.detailData.map((row, index) => {
            const backendRow = response.error.result.invoiceDetails[index];
            return {
              ...row,
              _backendValidation: {
                customerIsValid: backendRow.customerIsValid,
                billingSiteIsValid: backendRow.billingSiteIsValid
              }
            };
          });

  } else {
    this.handleError('Failed to submit request. Please try again.');
  }
}
  });
}




get isSubmitVisible(): boolean {

  return (
    !!this.editedMainRow ||
    this.editedDetailRows.length > 0 ||
    this.deletedDetailIds.length > 0 ||
     this.fileChanged
  );
}


 getFileDetails (e) {
      this.fileErrors = ''
    
      for (var i = 0; i < e.target.files.length; i++) { 
        if(this.selectedFiles.length < 5)
        {
          const fileSize = e.target.files[i].size;
           const fileMb = fileSize / 1024 ** 500;
           const allowedTypes = ['.csv', '.pdf', '.txt', '.xlsx','.eml','.msg'];
           const fileExtension = e.target.files[i].name.split('.').pop()?.toLowerCase();
           if (!allowedTypes.includes(`.${fileExtension}`)) {
               this.fileErrors = 'Invalid file type. Only .csv, .pdf, .txt, .xlsx, .eml, .msg are allowed.';
               return;
           }
           if (fileMb >= 500) {
              this.fileErrors = "Please select a file less than 500MB.";
              return;
            }            
            // for (let i = 0; i < this.selectedFiles.length; i++) 
            //   {
            //      // check if fdata[i].name already exists in this.files
            //      const fileExists = false;
            //      for (var pair of this.files.values()) { 
            //        if (pair.name == fdata[i].name) { 
            //          this.fileExists = true; 
            //        } 
            //      } 
            //      if (!fileExists) {
            //        this.files.append('file[]', fdata[i], fdata[i].name);
            //      }
            //   }       
          this.selectedFiles.push(e.target.files[i]);
          this.selectedFileNames.push(e.target.files[i].name);
          this.fileChanged=true;
           //.replace(/\.[^/.]+$/, "")); To remove file extensions, enable this line
        } else {
          this.fileErrors = 'You can only select 5 files'
        }
      }
    }

 uploadSelectedFiles(adjReqId: number): void {
  const formData = new FormData();

  for (const file of this.selectedFiles) {
    formData.append('files', file);
  }

  formData.append('adjReqId', adjReqId.toString()); // Optional, based on backend needs

  // ✅ PASS adjReqId as second argument here
  this.bulkRequestService.uploadBillingAdjustmentRequestFiles(formData, adjReqId).subscribe({
   
    error: () => {
      this.handleError('File upload failed.');
    }
  });
}




  removeFile(index: number): void {
      this.fileErrors = ''
      this.selectedFiles.splice(index, 1);
      this.selectedFileNames.splice(index, 1);
      this.fileChanged=true;
    }
  private handleError(message: string): void {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: message,
      confirmButtonColor: '#3b82f6'
    });
  }
  private hasValidationErrors(): boolean {
  // 🔹 Validate edited main row
  if (this.editedMainRow) {
    // for (const field in this.firstTableValidationRules) {
    //   const validators = this.firstTableValidationRules[field];
    //   const control = new FormControl(this.editedMainRow[field], validators);
    //   if (control.invalid) return true;
    // }
  }

  // 🔹 Validate edited detail rows (new or updated)
  const rowsToCheck = [...this.detailData]; // All current rows
  for (const row of rowsToCheck) {
    // for (const field in this.detailsValidationTableRules) {
    //   const validators = this.detailsValidationTableRules[field];
    //   const control = new FormControl(row[field], validators);
    //   if (control.invalid) return true;
    // }

    // // 🔸 Backend validation: customerIsValid or billingSiteIsValid
    // if (row._backendValidation) {
    //   if (row._backendValidation.customerIsValid === false ||
    //       row._backendValidation.billingSiteIsValid === false) {
    //     return true;
    //   }
    // }

    // 🔸 Additional logic: Remit Address required if Check Request is 'Yes'
    if (row['Check Request']?.toLowerCase() === 'yes' && !row['Remit Address']) {
      return true;
    }
  }

  return false; // ✅ All validations passed
}
  conditionalRemitAddressValidator() {
  return (control: FormControl) => {
    const row = control?.parent?.value;

    if (!row) return null; // no parent yet (initial phase)

    const checkRequest = String(row['Check Request'] || '').toLowerCase().trim();
    const remitAddress = String(control.value || '').trim();

    if (checkRequest === 'yes' && !remitAddress) {
      return { remitRequired: true };
    }

    return null;
  };
}
checkRequestValidator() {
  return (control: FormControl) => {
    const value = String(control.value || '').trim().toLowerCase();

    // Allow only 'yes' or 'no'
    if (value && value !== 'yes' && value !== 'no') {
      return { invalidCheckRequest: true };
    }

    return null;
  };
}
  private updateTopAmountFromTable(): void {
  if (!this.detailData || this.detailData.length === 0) return;

  const sum = this.detailData.reduce((total, row) => {
    const val = parseFloat(row['Amount']);
    return total + (isNaN(val) ? 0 : val);
  }, 0);

  // Update the topData "Amount" field
  if (this.selectedMainRow) {
    this.selectedMainRow['Net Amount'] = sum.toFixed(2);
  }
 
}

}
